import React, { useCallback } from "react";

export const useMenu = () => {
    const [anchorEl, setAnchorEl] = React.useState<(EventTarget & HTMLButtonElement) | null>(null);
    const open = Boolean(anchorEl);

    // eslint-disable-next-line
    const handleOpen = useCallback((e: any) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    }, []);

    const handleClose = useCallback((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation();
        e.preventDefault();
        setAnchorEl(null);
    }, []);

    return {
        handleOpen,
        handleClose,
        anchorEl,
        open,
    };
};
